import { backendUrl } from '@shared/constants/urls/appUrls';
import { fetchWithAuth } from '@shared/utils/auth';

export async function searchForecasterByCoinTwitter(coinIds) {
  const ids = Array.isArray(coinIds) ? coinIds.join(',') : coinIds;
  const url = `${backendUrl}/api/forecasters/tweets/search/?coin_ids=${ids}`;

  try {
    const response = await fetchWithAuth(url, { method: 'GET' });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении данных Forecasters');
    }
    return await response.json();
  } catch (error) {
    console.error('API searchForecasterByCoinTwitter error:', error);
    throw error;
  }
}

export async function searchForecasterByCoinTelegram(coinIds) {
  const ids = Array.isArray(coinIds) ? coinIds.join(',') : coinIds;
  const url = `${backendUrl}/api/forecasters/telegram/search/?coin_ids=${ids}`;

  try {
    const response = await fetchWithAuth(url, { method: 'GET' });
    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.message || 'Ошибка при получении данных Forecasters');
    }
    return await response.json();
  } catch (error) {
    console.error('API searchForecasterByCoinTelegram error:', error);
    throw error;
  }
}